import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ConfiguratorModeModal from "@src/modules/DeviceConfigurator/ConfiguratorModeModal.vue";
import CustomDeviceConfigurationModal from "@src/modules/DeviceConfigurator/CustomDeviceConfigurationModal.vue";
import { ref } from "vue";
import defineDeviceState from "@src/composables/defineDeviceState";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceConfigurator',
  emits: ["apply", "close"],
  setup(__props, { emit }) {

const deviceState = defineDeviceState();



const isConfiguratorOptionsVisible = ref(true);
const isCustomConfiguratorVisible = ref(false);

function openCustomConfigurator(): void {
  isConfiguratorOptionsVisible.value = false;
  isCustomConfiguratorVisible.value = true;
}

function close() {
  isCustomConfiguratorVisible.value = false;
  emit("close");
}

function applyCustomConfiguration(
  width: number,
  height: number,
  modules: Array<string>,
): void {
  deviceState.buildFromParams(width, height, modules);
  emit("close");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isConfiguratorOptionsVisible.value)
      ? (_openBlock(), _createBlock(ConfiguratorModeModal, {
          key: 0,
          onClose: close,
          onApply: applyCustomConfiguration,
          onSelectCustom: openCustomConfigurator
        }))
      : _createCommentVNode("v-if", true),
    (isCustomConfiguratorVisible.value)
      ? (_openBlock(), _createBlock(CustomDeviceConfigurationModal, {
          key: 1,
          onClose: close,
          onApply: applyCustomConfiguration
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})